"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
if (typeof String.prototype.padStart !== 'function') {
    String.prototype.padStart = function padStart(maxLength, fillString) {
        maxLength = maxLength >> 0;
        fillString = String((typeof fillString !== 'undefined' ? fillString : ' '));
        if (this.length > maxLength) {
            return String(this);
        }
        else {
            maxLength = maxLength - this.length;
            if (maxLength > fillString.length) {
                fillString += fillString.repeat(maxLength / fillString.length);
            }
            return fillString.slice(0, maxLength) + String(this);
        }
    };
}
